import { z } from 'zod'

/**
 * Zod schema for the `init-window` IPC response.
 * Validates data at the IPC boundary to catch malformed main-process responses at runtime.
 */
export const windowInitPropsSchema = z.object({
  width: z.number(),
  height: z.number(),
  maximizable: z.boolean(),
  minimizable: z.boolean(),
  platform: z.enum(['win32', 'darwin', 'linux', 'web']),
  windowType: z.enum(['main', 'setup', 'onboarding', 'preferences']).optional(),
})

export type WindowInitPropsValidated = z.infer<typeof windowInitPropsSchema>
